import axios from 'axios'
import ParamsUtil from 'utils/params-util'

const API_PATH = 'api/v2/admins/finance/payments'

const FinancePaymentsApi = {
  /**
   * Get all OR filtered Payments
   * Invoke `GET admins/finance/payments
   * @param {String} q - query to search by deal or payment reference numbers
   */
  get: async ({
    page              = 1,
    per_page          = 10,
    sort_by           = 'payments.created_at',
    sort_dir          = 'desc',
    q                 = '',
    scope             = 'need_action',
  }) => {
    let params = {
      page              : page,
      per_page          : per_page,
      sort_by           : sort_by,
      sort_dir          : sort_dir,
      q                 : q,
      scope             : scope,
    }

    params = ParamsUtil.removeEmptyAttributes(params)

    const path = API_PATH

    const response = await axios.get(path, { params })

    return response
  },

  /**
   * Get specific Payment
   * Invoke `GET admins/finance/payments/:id
   * @param {Number} paymentId - id of Payment
   */
  show: async ({ paymentId }) => {
    const path = `${API_PATH}/${paymentId}`

    const response = await axios.get(path)

    return response
  },

  /**
   * Update down payment of a Deal
   * Invoke `GET admins/finance/payments/:id/update_down_payment
   * @param {Number} paymentId - id of Payment
   */
  updateDownPayment: async ({ paymentId, fullyPaid, downPayment }) => {
    const path = `${API_PATH}/${paymentId}/update_down_payment`
    const params = {
      down_payment: downPayment,
      fully_paid: fullyPaid,
    }

    const response = await axios.post(path, params)

    return response
  },

  /**
   * Confirm Payment by manual transfer is received
   * Invoke `GET admins/finance/payments/:id/confirm_manual_transfer
   * @param {Number} paymentId - id of Payment
   */
  confirm: async ({ paymentId }) => {
    const path = `${API_PATH}/${paymentId}/confirm_manual_transfer`

    const response = await axios.post(path)

    return response
  },

  /**
   * Reject Payment by manual transfer
   * Invoke `GET admins/finance/payments/:id/reject_manual_transfer
   * @param {Number} paymentId - id of Payment
   */
  reject: async ({ paymentId }) => {
    const path = `${API_PATH}/${paymentId}/reject_manual_transfer`

    const response = await axios.post(path)

    return response
  },

  /**
   * Get history list of a deal
   * Invoke `GET admins/sales/deals/:id/list_history
   * @param {Number} dealId - id of Deal
   */
  listHistory: async ({ dealId }) => {
    const path = `${API_PATH}/${dealId}/list_history`

    const response = await axios.get(path)

    return response
  },

  /**
   * Get specific history of a deal
   * Invoke `GET admins/sales/deals/get_history
   * @param {Number} historyId - id of Deal
   */
  getHistory: async ({ historyId }) => {
    const path = `${API_PATH}/get_history?history_id=${historyId}`

    const response = await axios.get(path)

    return response
  },
}

export default FinancePaymentsApi
